/* eslint no-unused-vars: 1 */

/* Used in CMS Page-ID: 418939 */
var initMNPApp = function() {
    'use strict';

    /** the init */
    angular.module('mnp', [ 'mnp.common', 'mnp.modules', 'mnp.config'
    ]).run([ '$rootScope', '$state', '$stateParams', 'trackingSrv', function($rootScope, $state, $stateParams, trackingSrv) {

        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;

        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            vf.toggle.init($('.ng-content'));

            var siteStructure = trackingSrv.getSiteStructure();
            trackingSrv.trackPageView(siteStructure);
        });
    }

    ]).controller('mnpCtrl', function($scope) {
        var vm = this;
        vm.$onInit = function () {
        };

    }).config([ '$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise('/');

        /**
         * route for startpage
         */
        $stateProvider.state('home', {
            url: '/',
            templateUrl: window.PARTIALURL + '/initialScreen.html',
            controller: 'shopAuthCtrl',
            controllerAs: 'vm',
            params: {
                data: null
            }

        /**
         * routes for login
         */
        }).state('mobileLogin', {
            url: '/shopLogin',
            templateUrl: window.PARTIALURL + '/login/CustomerData/login.msisdn.html',
            controller: 'shopAuthCtrl',
            controllerAs: 'vm',
            params: {
                data: null
            }

        }).state('customerLogin', {
            url: '/meinVodafonelogin',
            templateUrl: window.PARTIALURL + '/login/myVF/login.customerAccount.html',
            controller: 'shopAuthCtrl',
            controllerAs: 'vm',
            params: {
                data: null
            }

        }).state('contractChooser', {
            url: '/vertragwaehlen',
            templateUrl: window.PARTIALURL + '/porting.chooseContract.html',
            controller: 'shopAuthCtrl',
            controllerAs: 'vm',
            params: {
                data: null
            }

        }).state('notAllowed', {
            url: '/andererVertragLogin',
            templateUrl: window.PARTIALURL + '/porting.otherLogin.html',
            controller: 'shopAuthCtrl',
            controllerAs: 'vm',
            params: {
                data: null
            }

        /**
         * routes for porting
         */
        }).state('porting', { // TODO: call from shop
            url: '/rufnummern-mitnahme-nicht-eingeloggt',
            templateUrl: window.PARTIALURL + '/porting.init.html',
            controller: 'portingCtrl',
            controllerAs: 'vm'

        }).state('porting-logged', {
            url: '/rufnummern-mitnahme-eingeloggt',
            templateUrl: window.PARTIALURL + '/porting.init-logged.html',
            controller: 'portingCtrl',
            controllerAs: 'vm',
            params: {
                data: null
            }

        }).state('chooseContractType', {
            url: '/auswahl',
            templateUrl: window.PARTIALURL + '/porting.chooseContractType.html',
            controller: 'portingCtrl',
            controllerAs: 'vm',
            params: {
                data: null
            }


        }).state('chooseAlreadyCanceled', {
            url: '/auswahl/vertragbeendet',
            templateUrl: window.PARTIALURL + '/porting.chooseAlreadyCanceled.html',
            controller: 'portingCtrl',
            controllerAs: 'vm',
            params: {
                data: null
            }

        }).state('enterNotCanceledFlow', {
            url: '/auswahl/vertragaktiv/kuendigungsdatum',
            templateUrl: window.PARTIALURL + '/not-canceled/porting.stepperNotCanceled.html',
            controller: 'portingCtrl',
            controllerAs: 'vm',
            params: {
                data: null
            }

        }).state('enterCanceledFlow', {
            url: '/auswahl/vertragbeendet/kuendigungsdatum',
            templateUrl: window.PARTIALURL + '/canceled/porting.stepperAlreadyCanceled.html',
            controller: 'portingCtrl',
            controllerAs: 'vm',
            params: {
                data: null
            }

        }).state('enterPrepaidFlow', {
            url: '/auswahl/rufnummern-mitnahme',
            templateUrl: window.PARTIALURL + '/prepaid/porting.stepperNotCanceled.html',
            controller: 'portingCtrl',
            controllerAs: 'vm',
            params: {
                data: null
            }

        }).state('executeForm', {
            url: '/rufnummern-mitnahme/verarbeitung',
            templateUrl: window.PARTIALURL + '/porting.form.process.html',
            controller: 'portingCtrl',
            controllerAs: 'vm',
            params: {
                data: null
            }

        });
    }
    ]);
};
